<header class="qira-page-header">
  <div class="qira-page-header__body">
    <div *ngIf="backLink || eyebrow" class="qira-page-header__eyebrow-row">
      <button *ngIf="backLink"
              type="button"
              mat-icon-button
              class="qira-back-btn"
              [routerLink]="backLink"
              [attr.aria-label]="backAriaLabel">
        <mat-icon>arrow_back</mat-icon>
      </button>

      <span *ngIf="eyebrow" class="qira-pill">{{ eyebrow }}</span>
    </div>
    <h1 class="qira-page-header__title">{{ title }}</h1>
    <p *ngIf="description" class="qira-page-header__description">{{ description }}</p>
  </div>
  <div class="qira-page-header__actions">
    <ng-content></ng-content>
  </div>
</header>
